import React, { useState } from "react";
import MainDashboard from "../MainDashboard/MainDashboard";

const AdminMainDashboard = () => {
  return (
    <>
      <MainDashboard />
    </>
  );
};

export default AdminMainDashboard;
